import { getStore } from "../store/findInMessageStore";
import type FindInMessageViewState from "../store/schema/FindInMessageViewState";

// this function returns the FindInMessageViewState from the store for the given context
export default function getFindInMessageViewState(context: string): FindInMessageViewState | undefined {
    if (!getStore().findInMessageViewStates.has(context)) {
        getStore().findInMessageViewStates.set(context, {
            isCalloutVisible: false,
            searchString: "",
            numberOfMatches: 0,
            currentMatchIndex: 0,
            matchesPerItemId: [],
            itemPartCollapsedExpandedIncrementor: 0,
            lastActionPerformed: undefined,
        });
    }
    
    return getStore().findInMessageViewStates.get(context);
}
